import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {  map,  catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
@Injectable({
    providedIn: 'root',
})
export class UserService {
    constructor(private http: HttpClient) { }

    getBranch(){
        return [
            {
                value:0,
                viewValue:"helper.lbl.mk"
            },
            {
                value:1,
                viewValue:"helper.lbl.cwb"
            },
            {
                value:2,
                viewValue:"helper.lbl.yl"
            },
            {
                value:3,
                viewValue:"helper.lbl.tw"
            },
            {
                value:4,
                viewValue:"helper.lbl.all"
            }
        ].sort((a,b)=>a.value-b.value);
    }
    
    getUserList(): Observable<any> {
        return this.http.get(environment.url+'/users', { withCredentials: true,observe: 'body',headers:this.getHttpHeaders()}).pipe(map(x=>x['users']));
    }

    getPersonalInfo():Observable<any>{
        return this.http.get(environment.url+'/users/current/session', { withCredentials: true,observe: 'body',headers:this.getHttpHeaders()});                }

    getUserById(id) {
        return this.http.get(environment.url + `/users/${id}`, { withCredentials: true, observe: 'body', headers: this.getHttpHeaders() });
    }

    changePassword(id,data){
        return this.http.put(environment.url + `/users/${id}/password`,data, { withCredentials: true, observe: 'body', headers: this.getHttpHeaders() });
    }
    changePersonalPassword(data){
        return this.http.put(environment.url + `/users/password`,data, { withCredentials: true, observe: 'body', headers: this.getHttpHeaders() });
    }

    editPersonalInfo(data){
        return this.http.put(environment.url + `/users`,data, { withCredentials: true, observe: 'body', headers: this.getHttpHeaders() });
    }

    editUser(id,data){
        return this.http.put(environment.url + `/users/${id}`,data, { withCredentials: true, observe: 'body', headers: this.getHttpHeaders() });
    }

    createUser(data){
        return this.http.post(environment.url + `/users`,data, { withCredentials: true, observe: 'body', headers: this.getHttpHeaders() });

    }

    login(data):Observable<any>{
        return this.http.post(environment.url+'/users/login',data, { withCredentials: true,observe: 'body',headers:this.getHttpHeaders()});
    }
    
    logout():Observable<any>{
        return this.http.post(environment.url+'/users/logout',{}, { withCredentials: true,observe: 'body',headers:this.getHttpHeaders()});
    }

    getHttpHeaders(){
        let headers = new HttpHeaders();
        headers = headers.set('Accept', 'application/json');
        headers = headers.set('Accept-Language', 'zh-HK');
        return headers;
    }

    deactivateUser(id){
        return this.http.put(environment.url + `/users/${id}/deactivate`,{}, { withCredentials: true, observe: 'body', headers: this.getHttpHeaders() });
    }

}